import React, {useContext, useState} from 'react';

import {Integer} from '@pb/kit-component-formatters';
import {Input} from '@pb/kit-component-input-v2';
import Label from '@pb/kit-component-label';
import {LocaleContext} from '@pb/kit-context-locale';

type Props = {
    label?: React.ReactNode,
    value: number | undefined,
    maxValue: number,
    onChange: (value: number | undefined) => void,
};

export const LocaleNumberInput = ({label, value, maxValue, onChange}: Props) => {
    const {locale} = useContext(LocaleContext);
    const [focused, setFocused] = useState(false);

    const getDisplayValue = (v: number | undefined) =>
        v != null ? Integer.format(v, locale) : '';

    return (
        <>
            {label ? <Label>{label}</Label> : null}
            <Input
                type={focused ? 'number' : 'text'}
                step={1}
                rootProps={{style: {width: '100%'}}}
                value={focused
                    ? (value ?? '')
                    : getDisplayValue(value)}
                onChange={e => {
                    if (focused) {
                        onChange(
                            e.target.value
                                ? Math.min(Number(e.target.value), maxValue)
                                : undefined,
                        );
                    }
                }}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            />
        </>
    );
};
